
import React, { useState, useEffect } from 'react'
import API from '../utils/api';
import { Container, Button, Table } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import swal from 'sweetalert';
import Error from '../Error';
import { PlusLg, ArrowClockwise } from 'react-bootstrap-icons';
import Pagination from '../utils/Pagination';
import Card from 'react-bootstrap/Card';

import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { formatearFecha } from '../utils/FormatearFecha'
import ExportExcel from '../utils/excelexports';

import axios from 'axios';

const Productos = () => {

    var url = API.urlAPI
    const urlProductos = url + "productos"
    const [search, setSearch] = useState("")

    const [productos, setProductos] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(8);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = productos.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(productos.length / recordsPerPage)
  

    const [error, setError] = useState(false)


    const [ProductoSeleccionado, setProductoSeleccionado] = useState({

        IdProducto: '',
        Descripcion: ''
      })

    //Get Productos
    const handleChange = e => {
        const { name, value } = e.target;
        setProductoSeleccionado({
          ...ProductoSeleccionado,
          [name]: value
        });
        console.log(ProductoSeleccionado);
      }
    
  const getProductos = () => {
    fetch(
      urlProductos
    )
      .then((r) => r.json())
      .then((r) => setProductos(r))
    console.log(productos);
  }

  useEffect(() => {
    getProductos();
  }, [])



  const ContainerStyle = {
    boxShadow: '1px 2px 9px white',
    background: 'white',
    justifyContent: 'center'
  };

  const searcher = (e) => {
    setSearch(e.target.value)
  }
  const results = !search ? currentRecords : productos.filter((dato) => dato.Descripcion.toLocaleLowerCase().includes(search.toLocaleLowerCase()))



  const handleSubmit = (e) => {
    e.preventDefault();
    const PostProductos = {
      Descripcion: ProductoSeleccionado && ProductoSeleccionado.Descripcion
    }

    if ([PostProductos.Descripcion].includes('')) {
      setError(true)
      return;
    }

    setError(false)
    axios.post(urlProductos, PostProductos)
      .then(response => {
        const result = response.data;
        swal({
          title: "Gasto creado correctamente!",
          icon: "success",
          showConfirmButton: false,
          timer: 4000
        });
        setProductoSeleccionado({
          IdProducto: '',
          Descripcion: ''
        })
        console.log(result)
        console.log("Detalle Post: ", PostProductos)
        getProductos()



      }
      )
      .catch(err => {
        console.log(err)
        console.log(urlProductos)
        console.log(PostProductos)
        swal({
          title: "Ocurrió un error, contactar con el administrador",
          icon: "error",
          showConfirmButton: false,
          timer: 4000
        });
      })
  };

  const [modalEditar, setModalEditar]=useState(false);

  
const abrirCerrarModalEditar=()=>{
    setError(false)
    setModalEditar(!modalEditar);
    
    
  }
  const seleccionarProducto = (item, caso) => {
    setProductoSeleccionado(item);
    (caso === "Eliminar") ?
      console.log("Eligio otro") : abrirCerrarModalEditar();
  }  

  const updateProducto =  () => {

    const{Descripcion} = ProductoSeleccionado
   
    if ( [Descripcion].includes('')){
          setError(true)
          return;
        }
    setError(false)
     axios.put(urlProductos + "/" + ProductoSeleccionado.IdProducto, ProductoSeleccionado)
      .then(response => {
        const result = response.data;
        abrirCerrarModalEditar();
        swal({
          title: "Producto Editado Correactamente!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
        console.log(result);
        setProductoSeleccionado({
          IdProducto: '',
          Descripcion: ''
        })
        getProductos();
      }).catch(error => {
        console.log(error);
      })
  }


  return (
    <>
    <Container  >
        <Card style={ContainerStyle} >
          <Card.Header style={{ background: "#005187", color: "white" }}><h3>Administración Productos</h3></Card.Header>
          <Card.Body  >
            <Form >

              <Row className="mb-3">
                <Form.Group as={Col}>

                  <InputGroup>
                    <FloatingLabel
                      controlId="floatingTextarea1" label="Descripción Producto"
                    >
                      <Form.Control as="textarea" aria-label="Descripcion" name="Descripcion" value= {ProductoSeleccionado.Descripcion} required onChange={handleChange} />
                    </FloatingLabel>
                  </InputGroup>
                </Form.Group> 
              </Row>
                  <br></br>
                  <Button variant='success'
                    style={{
                      border: 'none',
                      borderRadius: '50%',
                      height: '65px',
                      width: '65px'
                    }}
                    type="submit"
                    onClick={(e) => handleSubmit(e)}

                  ><PlusLg size={"lg"}></PlusLg></Button>
             
              {error &&
                <Error><p>Todos los campos son requeridos</p></Error>
              }
            </Form>
          </Card.Body>
        </Card>
     
      <br></br>
      <Card style={ContainerStyle} >
      <Card.Header style={{ background: "#005187", color:"white"}}><h3>Listado Productos</h3></Card.Header>  
      <Card.Body>
            <br></br>
      <div>
        <input value={search} onChange={searcher} type="text" placeholder='Busqueda por Descripcion' className='form-control' />
        <br></br>
      </div>
      <Table responsive>
      <thead  style={{ background: "#74a7e4", color: "white"}}>
          <tr>
            <th>Id Producto</th>
            <th>Descripcion</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {results.map((item) =>
            <tr key={item.IdProducto}>
              <td>{item.IdProducto}</td>
              <td>{item.Descripcion}</td>
              <td>
                <Button size='sm' variant='warning' onClick={() => seleccionarProducto(item, "Editar")}><ArrowClockwise style={{color: "white"}}/></Button>

              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Row>
        <Col> <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        /></Col>
        <Col><ExportExcel excelData={results} fileName={"Productos"} /></Col>
      </Row>
</Card.Body>

<Modal isOpen={modalEditar}>
      <ModalHeader>Editar Cliente</ModalHeader>
      <ModalBody>
      <div className="form-group">
      {error && 
               <Error><p>El campo descripción es requerido</p></Error>
      }
      <label>ID: </label>
          <br />
          <input type="text" className="form-control" readOnly value={ProductoSeleccionado && ProductoSeleccionado.IdProducto}/>
          <br />
          <label>Descripcion: </label>
          <br />
          <input type="text" className="form-control" name="Descripcion"  onChange={handleChange} value={ProductoSeleccionado && ProductoSeleccionado.Descripcion}/>
          <br />
         
        </div>
       
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-primary" onClick={()=>updateProducto()}>Editar</button>{"   "}
        <button className="btn btn-danger" onClick={()=>abrirCerrarModalEditar()}>Cancelar</button>
      </ModalFooter>
    </Modal>
</Card>
    
      </Container>
    </>
  )
}

export default Productos